<template>
  <div class="head_wrap">
    <div class="site_nav">
      <div class="center_box fc_jb">
        <div class="l_site">
          <div class="animate">
            {{ $store.getters.config.SCROLL_THE_TEXT.value }}
          </div>
        </div>
        <div class="r_site">
          <span v-if="$store.getters.phone"
            >欢迎（{{ $store.getters.username }}）</span
          >
          <span
            class="pointer"
            v-if="!$store.getters.token"
            @click="handleLogin"
            >&nbsp;登录&nbsp;</span
          >
          <!-- <span
          class="pointer"
          v-if="$store.getters.token"
          @click="handleJoinVip"
          >进入会员中心</span
        > -->
          <span
            class="pointer color"
            v-if="$store.getters.token"
            @click="onPersonal()"
            >进入个人中心</span
          >
          <span
            class="pointer color"
            v-if="$store.getters.token"
            @click="handleLoginOut"
            >退出登录</span
          >
        </div>
      </div>
    </div>
    <div class="container">
      <div class="center_box fc_jb">
        <img
          @click="$router.push('/')"
          class="pointer"
          referrerpolicy="no-referrer"
          src="@/assets/images/login/logo.png"
        />
        <div class="r_container flex">
          <img
            v-if="banner_list.length"
            referrerpolicy="no-referrer"
            :src="banner_list[0].image_path"
            @click="openUrl()"
          />
          <div class="tips">
            <a
              class="fc"
              v-for="item in commissions"
              :key="item.id"
              :href="item.website"
              target="_blank"
            >
              <img src="@/assets/images/index/icon_tam.png" alt="" />
              <span>{{ item.title }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="navbar">
      <div class="center_box fc">
        <div
          v-for="(menu_item, menu_index) in menu_list"
          :key="menu_item.id"
          :class="[
            'menu_item',
            active_index === menu_index && 'active_menu_item',
          ]"
          @click="handleMenuClick(menu_item.url, menu_index)"
        >
          {{ menu_item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpGet } from "@/apis";

export default {
  name: "HelloWorld",
  data() {
    return {
      active_index: 0,
      menu_list: [],
      banner_list: [],
      commissions: [],
    };
  },
  watch: {
    $route(to, from) {
      this.active_index = this.menu_list.findIndex((v) => v.url === to.path);
    },
  },
  mounted() {
    this.getBanner();
    this.getCommissions();
    if (this.$store.getters.navigation.length) {
      this.menu_list = this.$store.getters.navigation;
    }
  },
  methods: {
    async getBanner() {
      const res = await httpGet("/api/information/banner", {
        place: "home_top",
      });
      if (res.code === 200) {
        this.banner_list = res.data;
      } else {
        this.$message.error(res.message);
      }
    }, // banner图
    async getCommissions() {
      const res = await httpGet("/api/information/ministries_commissions");
      if (res.code === 200) {
        this.commissions = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    onPersonal() {
      this.$router.push("/personal_center");
    },
    handleMenuClick(path, index) {
      this.active_index = index;
      if (index > 0 && index < 6) {
        // if (index >= 3 && index <= 5 && !this.$store.getters.token) {
        //   this.$router.push("/login");
        //   return;
        // }
        this.$router.push(path + "?cate_ids=" + index);
        return;
      }
      this.$router.push(path);
    },
    handleLogin() {
      this.$router.push("/login");
    },
    handleLoginOut() {
      this.$store.dispatch("user/logout");
      this.$message.success("退出成功!");
      this.$router.push("/login");
    },
    handleJoinVip() {
      this.$router.push("/join_membership");
    },
    openUrl() {
      window.open(this.banner_list[0].url);
    },
  },
};
</script>

<style lang="scss" scoped>
.site_nav {
  background: #f5f7fa;

  .center_box {
    height: 44px;
    padding-left: 188px;
  }

  .l_site {
    overflow: hidden;
  }

  .animate {
    padding-left: 20px;
    font-size: 16px;
    font-family: AppleSystemUIFont;
    color: red;
    line-height: 18px;
    display: inline-block;
    white-space: nowrap;
    animation: 30s wordsLoop linear infinite normal;
  }

  @keyframes wordsLoop {
    0% {
      transform: translateX(30%);
      -webkit-transform: translateX(30%);
    }

    100% {
      transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
  }

  @-webkit-keyframes wordsLoop {
    0% {
      transform: translateX(30%);
      -webkit-transform: translateX(30%);
    }

    100% {
      transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
  }

  .r_site {
    min-width: 370px;
    padding-left: 24px;
    font-size: 14px;
    font-family: AppleSystemUIFont;
    color: #909399;
    line-height: 17px;
    text-align: right;

    .color {
      margin-left: 24px;
      color: #ff910f;
    }
  }
}

.container {
  padding: 20px 0;

  .center_box {
    > img {
      width: 188px;
      height: 80px;
    }

    .r_container {
      > img {
        height: 87px;
        cursor: pointer;
      }

      .tips {
        margin-left: 32px;

        > a {
          margin-bottom: 5px;
          font-size: 14px;
          font-family: AppleSystemUIFont;
          color: #909399;
          line-height: 17px;

          img {
            width: 12px;
            margin-right: 3px;
            vertical-align: middle;
          }
        }
        > a:hover {
          color: #0f8cff;
          text-decoration: underline;
        }

        > a:visited {
          color: #ff0000;
          text-decoration: underline;
        }
      }
    }
  }
}

.navbar {
  background: linear-gradient(180deg, #1f9ff9 0%, #0071c2 100%);

  .center_box {
    justify-content: space-around;

    .menu_item {
      width: 150px;
      height: 48px;
      font-size: 16px;
      font-family: AppleSystemUIFont;
      color: #ffffff;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
    }

    .active_menu_item {
      background: #146cbe;
      box-shadow: inset 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    }
  }
}

/* Pc */
@media screen and (min-width: 980px) {
  // .site_nav .center_box {
  //   height: 44px;
  // }
  .r_container {
    > img {
      width: 752px;
    }
  }
}

/* Mobile */
@media screen and (max-width: 980px) {
  // .head_wrap {
  //   display: none;
  // }
  .site_nav .center_box {
    width: 880px;
  }
  .r_container {
    padding-right: 24px;
    > img {
      width: 552px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Head/Head.vue